import IonIcon from "../components/IonIcon";
import logo from "../images/logo.png";
import "../styles/dashboard_container.css";

// 마이즈 태블릿 해상도 1280 800

const DashBoardOnlyGas = () => {
  return (
    <div className="dashboard_container gas">
      <div className="wrapper column gas">
        <div className="layout_row between">
          <div className="logobox row_top gas">
            <div className="logo_wrapper">
              <img src={logo} alt="logo" />
              <span>스마트안전관리시스템</span>
            </div>
          </div>
          <div className="layout_row row_top">
            <div className="watchbox">
              <div className="date">2024년 06월 27일</div>
              <div className="time">13:35:58</div>
            </div>
          </div>
        </div>
        <div className="layout_row narrow_width">
          <div className="box gas">
            <div className="titlebox column box_titlebox margintop50">
              <div className="btns small gas">
                <button>방음하우스내부</button>
                <button>수직구 1#</button>
                <button className="on">수직구 2#</button>
              </div>
            </div>

            <div className="envboxs small gas">
              <div className="env">
                <div className="title">온도</div>
                <div className="amount">15.2</div>
                <div className="unit">°C</div>
              </div>
              <div className="env">
                <div className="title">습도</div>
                <div className="amount">45.2</div>
                <div className="unit">%</div>
              </div>
              <div className="env">
                <div className="title">미세먼지</div>
                <div className="amount">0</div>
                <div className="unit">㎍/m3</div>
              </div>
              <div className="env">
                <div className="title">초미세먼지</div>
                <div className="amount">0</div>
                <div className="unit">㎍/m3</div>
              </div>
              <div className="env">
                <div className="title">일산화탄소</div>
                <div className="amount">0</div>
                <div className="unit">ppm</div>
              </div>
              <div className="env">
                <div className="title">산소</div>
                <div className="amount">20.73</div>
                <div className="unit">%</div>
              </div>
              <div className="env">
                <div className="title">황화수소</div>
                <div className="amount">0</div>
                <div className="unit">ppm</div>
              </div>
              <div className="env">
                <div className="title">메탄가스</div>
                <div className="amount">0</div>
                <div className="unit">%</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashBoardOnlyGas;
